import { useState } from 'react';
import { ProductVariantColorViewModel, ProductVariantWeightViewModel } from '@/types/api';
import ColorVariant from '@/features/pdp-components/color-variant';
import VariantsLayoutWrapper from './variants-layout-wrapper';
import { VariantContextType } from '../../context/types';
import { useVariantContextValues } from '../../context/use-variant-context-values';
interface Props {
  isCarousel: boolean;
  clickHandler: (color: ProductVariantColorViewModel) => void;
  selectedColor: ProductVariantColorViewModel | undefined;
  selectedWeight: ProductVariantWeightViewModel | undefined;
  contextType: VariantContextType;
}
const ColorVariants = ({
  clickHandler,
  selectedColor,
  selectedWeight,
  isCarousel = false,
  contextType
}: Props) => {
  const [hoveredColor, setHoveredColor] = useState<ProductVariantColorViewModel>();
  const {
    uniqueColorVariants,
    hasColorOptions,
    allVariants
  } = useVariantContextValues(contextType);
  if (!hasColorOptions) return null;
  const handleMouseEnter = (color: ProductVariantColorViewModel) => setHoveredColor(color);
  const handleMouseLeave = () => setHoveredColor(undefined);
  const colorToDisplay = hoveredColor || selectedColor;
  return <>
            <span className='text-body-14 text-text-darkGray lg:text-body-16'>
                رنگ: {colorToDisplay && <span className='text-text-black'>{colorToDisplay.name}</span>}
            </span>

            <VariantsLayoutWrapper isCarousel={isCarousel} spacing={3} data-sentry-element="VariantsLayoutWrapper" data-sentry-source-file="color-variants.tsx">
                {uniqueColorVariants.map(variant => {
        const color = variant.color;
        if (!color?.id) return null;
        let isSalable = variant.isSalable || false;
        if (selectedWeight?.value) {
          isSalable = allVariants?.find(v => selectedWeight?.value === v.weight?.value && v.color?.id === color.id)?.isSalable || false;
        }
        return <ColorVariant className={isCarousel ? 'keen-slider__slide !w-fit min-w-fit justify-center' : ''} key={color.id} color={{
          id: color.id || '',
          name: color.name || '',
          hex: color.hexCode || '',
          image: color.imageUrl || ''
        }} notSaleable={!isSalable} selectedVariantId={selectedColor?.id || undefined} onClick={() => clickHandler(color)} handleMouseEnter={() => handleMouseEnter(color)} handleMouseLeave={handleMouseLeave} />;
      })}
            </VariantsLayoutWrapper>
        </>;
};
export default ColorVariants;